export const approach = [
  {
    n: "01",
    title: "Entender antes de construir",
    text: "Antes de escribir código busco entender el proceso real: qué se rompe, a quién afecta y qué significa que el problema esté resuelto.",
  },
  {
    n: "02",
    title: "Elegir con criterio",
    text: "No sumo tecnología porque sí. Elijo el stack que tiene sentido para el problema y puedo justificar cada decisión técnica.",
  },
  {
    n: "03",
    title: "Construir pensando en producción",
    text: "Vengo de soporte y operaciones en sistemas críticos: sé lo que cuesta un bug en producción. Escribo código mantenible, no solo funcional.",
  },
  {
    n: "04",
    title: "Iterar con feedback real",
    text: "Trabajo con metodologías ágiles, entrego en ciclos cortos y ajusto según feedback de usuarios reales, no supuestos.",
  },
  {
    n: "05",
    title: "Seguir aprendiendo",
    text: "Entre Power Platform y arquitectura hexagonal: me muevo entre low-code y backend puro porque disfruto aprender herramientas nuevas.",
  },
];
